import React from 'react'
import theme from 'redesign/themes/main'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const Ellipse: React.FC<IconProps> = ({
  color = theme.palette.error.main,
  size = ICON_SIZE.xxs,
  viewBox = ICON_VIEWBOX.xxs,
  fillOpacity,
}) => (
  <SvgWrapper aria-label="PinEllipse" size={size} viewBox={viewBox} fill="none">
    <circle cx="4" cy="4" r="4" fill={color} fillOpacity={fillOpacity} />
  </SvgWrapper>
)

export default Ellipse
